import React, { useState } from "react";

import {
  Box,
  Button,
  Dialog,
  IconButton,
  makeStyles,
  Table,
  TableBody,
  TableCell,
  TableRow,
  TextField,
  Theme,
  Typography
} from "@material-ui/core";
import { useDispatch } from "react-redux";
import { fetchQuote } from "../../store/QuoteSlice";
import { Account } from "../../api/Types";
import { Quote } from "../../api/Quote/Quote";
import { colors } from "swyft-react-core";
import { toast } from "react-toastify";
import ClearIcon from "@material-ui/icons/Clear";
import { addExtraItemToQuote } from "../../api/SwyftApi";

const useStyles = makeStyles((theme: Theme) => ({
  margin: {
    margin: theme.spacing(1)
  },
  input: {
    width: "100%"
  },
  button: {
    margin: theme.spacing(1)
  },
  templateSelect: {
    "minWidth": 250,
    "color": colors.primary,
    "& h3": {
      "padding": theme.spacing(1),
      "paddingLeft": theme.spacing(3),
      "marginBottom": theme.spacing(1),
      "&:not(.head):not(.selected)": {
        cursor: "pointer"
      }
    },
    "& .head": {
      color: colors.white,
      backgroundColor: colors.primary
    },
    "& .selected": {
      color: colors.secondary,
      borderRight: `5px solid ${colors.secondary}`
    }
  },
  title: {
    "padding": theme.spacing(2),
    "marginLeft": 250 + theme.spacing(2),
    "display": "flex",
    "& .Button-label svg": {
      marginRight: theme.spacing(2)
    },
    "& button": {
      "marginLeft": theme.spacing(2),
      "&:disabled svg": {
        fill: colors.lightGrey,
        stroke: colors.lightGrey
      }
    }
  },
  main: {
    padding: theme.spacing(2)
  },
  fields: {
    "& tr": {
      "& td": {
        "borderBottom": 0,
        "&:first-of-type": {
          width: 100
        }
      }
    }
  },
  content: {
    marginTop: theme.spacing(2),
    border: "1px solid black",
    overflowY: "scroll",
    height: 400
  },
  actions: {
    "display": "flex",
    "justifyContent": "flex-end",
    "marginTop": theme.spacing(2),
    "& button": {
      minWidth: "10em",
      marginLeft: theme.spacing(3)
    }
  },
  commentDialog: {
    minWidth: 600,
    padding: theme.spacing(3),
    display: "flex",
    flexDirection: "column"
  },
  confirmDeleteDialog: {
    minWidth: 600,
    padding: theme.spacing(3),
    display: "flex",
    flexDirection: "column"
  }
}));

interface Props {
  isOpen: boolean;
  onClose: () => void;
  quote: Quote;
  account: Account;
}

interface State {
  productDescription: string;
  price: string;
  comfirmDeleteOpen: boolean;
}

export const ExtraItemModal: React.FC<Props> = (props) => {
  const dispatch = useDispatch();
  const classes = useStyles();

  const { quote } = props;

  const [state, setState] = useState<State>({
    productDescription: "Additional fixtures and fittings required to carry out installation",
    price: "0",
    comfirmDeleteOpen: false
  });

  const handleAdd = async () => {
    if (state.productDescription === "") {
      toast.error(`Enter a valid description`);
      return;
    }

    var price = Number(state.price);
    if (price <= 0) {
      toast.error(`Enter a valid price`);
      return;
    }

    await addExtraItemToQuote(quote, state.productDescription, price)
      .then(() => {
        dispatch(fetchQuote(quote.id));
        toast.success(`Added to quote`);
        props.onClose();
      })
      .catch((err) => {
        console.log(err);
        toast.error("Failed to add item");
      });
  };

  return (
    <React.Fragment>
      <Dialog
        open={props.isOpen}
        onClose={props.onClose}
        aria-labelledby="template-selection"
        aria-describedby="template-select"
        fullWidth={true}
        maxWidth="xl"
      >
        <Box className={classes.title}>
          <Box flexGrow={1} mt={"12px"}>
            <Typography variant="h2">Add Additional Items</Typography>
          </Box>
          <IconButton onClick={props.onClose}>
            <ClearIcon />
          </IconButton>
        </Box>

        <Box display="flex">
          <Box flexGrow={1} className={classes.main}>
            <Table className={classes.fields} size="small">
              <TableBody>
                <TableRow>
                  <TableCell>
                    <Typography variant="subtitle2">Description</Typography>
                  </TableCell>
                  <TableCell>
                    <Typography component="div" variant="body1">
                      <TextField
                        label="Item Description"
                        variant="outlined"
                        size="small"
                        value={state.productDescription}
                        onChange={(e) =>
                          setState({
                            ...state,
                            productDescription: e.target.value
                          })
                        }
                        className={classes.input}
                      />
                    </Typography>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>
                    <Typography variant="subtitle2">To</Typography>
                  </TableCell>
                  <TableCell>
                    <Typography component="div" variant="body1">
                      <TextField
                        label="Price"
                        variant="outlined"
                        size="small"
                        value={state.price}
                        onChange={(e) =>
                          setState({
                            ...state,
                            price: e.target.value.replace(/[^0-9.]/g, "")
                          })
                        }
                        className={classes.input}
                      />
                    </Typography>
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>

            <Box className={classes.actions}>
              <Button variant="contained" color="secondary" onClick={(_) => handleAdd()} className={classes.button}>
                Save
              </Button>
              <Button variant="outlined" color="secondary" onClick={(_) => props.onClose()} className={classes.button}>
                Cancel
              </Button>
            </Box>
          </Box>
        </Box>
      </Dialog>
    </React.Fragment>
  );
};
